import React from "react";
import "./media/css/App.css";
import "./media/css/index.scss";

import Startup from "./Components/Startup/Startup.mjs";
import TabBar from "./Components/TabBar.mjs";
import UserPalette from "./Controls/UserPalette.mjs";
import Simulazione from "./Components/Simulazione/Simulazione.mjs";
import IncomingMessagesChecker from "./Controls/IncomingMessagesChecker.mjs";
import appLib from "./libs/appLib.mjs";

const G = window.glob;

const exitGame = async () => {
	await appLib.closeGame();
	window.location.reload();
}

const App = class extends React.Component {
	constructor(props) {
		super(props);
		this.uid = G.generateUid("App");
		this.state = {
			mainOperation: G.getStatus("mainOperation") || G.getInitialPage() || {},
			currentLanguage: G.getLanguage(),
			gameChosen: G.getStatus("GameChosen"),
			lastGameChange: 0
		};
		if (!G.getStatus("mainOperation")) {
			G.setCurrentPage(this.state.mainOperation, true);
		}
		this.setTheme();
		this.renderContent = this.renderContent.bind(this);
		this.gameChosen = this.gameChosen.bind(this);
		this.setGame = this.setGame.bind(this);
	}

	setGame(g) {
		G.setStatus("Game", g);
		setTimeout(() => {
			this.setTimer(g)
		}, 100);
	}
	setTheme(s) {
		if ( typeof s === 'undefined' ) s = G.getStatus('AppInfo');
		if ( ! s?.domain) return;
		const b = window.document.body;
		Array.from( b.classList ).filter( c => c.startsWith('theme-') ).forEach( c => {
			b.classList.remove(c);
		});
		if ( s?.theme ) b.classList.add('theme-'+s.theme);
	}
	setTimer(g) {
		let timer;
		if (g?.id && g?.event) {
			const starte = g.event.find(e => (e.type === 'timerStarted'));
			const stope = g.event.find(e => (e.type === 'timerStopped'));
			if (starte && stope) {
				timer = {
					time: (new Date()).getTime(),
					timer: stope.data.elapsed,
					stopped: true
				};
			} else if (starte) {
				const delta = (new Date()).getTime() - g.lastupdate;
				timer = {
					time: (new Date()).getTime(),
					timer: (g.lastupdate + delta - starte.time - (g?.pause || 0))
				};
			}
		}
		G.setStatus('ElapsedTimer', timer);
	}

	gameChosen(c) {
		if (this.state.gameChosen?.feedStatus) {
			G.stopPoll(this.uid, this.state.gameChosen?.feedStatus);
		}
		if (!c?.id) {
			// this.setState({gameChosen: undefined, lastGameChange: 0});
			// G.setStatus("GameStatus", undefined );
			// this.setGame();
			return exitGame();
		}
		this.setState({ lastMail: 0, lastIm: 0 });
		G.getFeed(c.feedStatus).then((gs) => {
			if (Object.keys(gs || {}).length === 0) return exitGame();
			G.getFeed(c.feedData).then((gd) => {
				G.setStatus("GameStatus", gs);
				this.setGame(gd);
				this.setState({gameChosen: c, lastGameChange: gs.lastupdate});
				appLib.getPlayerStatus().then( ps =>{
					G.setStatus("PlayerStatus", ps);
				});
				G.startPoll(
					c.feedStatus,
					(s) => {
						if (s.lastupdate <= this.state.lastGameChange) return;
						G.getFeed(c.feedData).then((d) => {
							this.setGame(d);
							G.setStatus("GameStatus", s);
							this.setState({lastGameChange: s.lastupdate});
						});
					},
					this.uid
				);
			}).catch(() => {
				// window.setTimeout(() => {
				//     this.gameChosen(c);
				// }, 500);
			});
		}).catch(() => {
			// window.setTimeout(() => {
			//     this.gameChosen(c);
			// }, 500);
		}).finally( ()=>{
			setTimeout(()=>{
				if ( G.getStatus("GameStatus")?.id) {
					appLib.getPlayerStatus().then( ps =>{
						G.setStatus("PlayerStatus", ps);
					});
				}
			}, 2000);
		});
	}

	componentDidMount() {
		const isMobile = (parseInt(window.innerWidth) < 640);
		document.body.classList.toggle('mobile', isMobile);
		document.body.classList.toggle('desktop', !isMobile);
		G.register('AppInfo', (s) => {
			this.setTheme(s);
		}, this.uid);
		G.register("mainOperation", (m) => {
			this.setState({mainOperation: m});
		}, this.uid);
		G.register("GameChosen", (c) => {
			this.gameChosen(c);
		}, this.uid);
		if (this.state.gameChosen) setTimeout(() => {
			this.gameChosen(this.state.gameChosen);
		});
		G.register('windowResized', (w) => {
			const isMobile = (w.width < 640);
			document.body.classList.toggle('mobile', isMobile);
			document.body.classList.toggle('desktop', !isMobile);
		}, this.uid)
		G.register('NewMailReceived', md => {
			const lur = md?.lastupdate?.inbox ?? 0;
			const lus = this.state.lastMail ?? 0;
			if ( lur > lus ) {
				if ( lus) {
					G.setStatus("NotifyMail", true);
					G.setStatus("NotifyMailInbox", true);
					appLib.sound('email');
				}
				appLib.setPlayerStatus(lur,'lastMail');
				this.setState({lastMail: lur});
			}
		}, this.uid);
		G.register('NewImReceived', md => {
			const lur = md?.lastupdate ?? 0;
			const lus = this.state.lastIm ?? 0;
			if (lur > lus) {
				if (lus) {
					G.setStatus("NotifyDashboard", true);
					G.setStatus("NotifyIm", true);
					appLib.sound('im');
				}
				appLib.setPlayerStatus(lur,'lastIm');
				this.setState({lastIm : lur});
			}
		}, this.uid);
		G.register('PlayerStatus', (s) => {
			const ns = {};
			if ( s?.lastMail ) ns.lastMail = s.lastMail;
			if ( s?.lastIm ) ns.lastIm = s.lastIm;
			if (Object.keys(ns).length) this.setState(ns);
		},this.uid);
	}

	componentWillUnmount() {
		G.deregister(this.uid);
		G.stopPoll(this.uid);
	}

	renderContent(mo = {}) {
		if (mo.name !== "Startup" && !G.getStatus("AppInfo")) {
			window.setTimeout(() => {
				G.setCurrentPage("Startup");
			}, 100);
			return <p/>;
		}
		if (mo.name === "Startup") return <Startup/>;
		return <Simulazione/>;
	}

	render() {
		return (
			<div className="App" id={this.uid}>
				<IncomingMessagesChecker/>
				<TabBar/>
				<div className={"AppContent"}>
					{this.renderContent(this.state.mainOperation)}
				</div>
				<UserPalette/>
			</div>
		);
	}
};
export default App;
